import type { Organization } from './organization';
import type { UserType } from './user';

export interface Invitation {
    id: number;
    email: string;
    isExpired: boolean;
    userType: UserType;
}

export interface InvitationResponse {
    count: number;
    next: string | null;
    previous: string | null;
    results: Invitation[];
}
